import $ from 'jquery';
import { useHistory } from "react-router-dom";
import React, { Fragment, useContext, useEffect, useState, useRef } from "react";
import { ListarNotificacoesUsuario, MarcarComoLido } from '../../Services/Notificacao';
import AppContext from '../../Store/AppContext';
import NotificationItem from './NotificacaoItem/NotificacaoItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import "./CentralNotificacao.css";
const images = require.context("../../assets/img/icones/pages", true);
const iconeSearch = images("./search.png");


function initialState() {
  return {
    notificacoes: [],
    totalNotificacao: 0,
  };
}
export const hideModal = () => {
  $("#modalCentralNotificacao").modal('hide');
};

const CentralNotificacao = () => {
  const history = useHistory();
  const { showLoading, hideLoading } = useContext(AppContext);
  const [CentralNotificacaoValues, setCentralNotificacaoValues] = useState(initialState());

  const intervaloId = useRef(null);

  useEffect(() => {
    buscarNotificacoesHandler();

    intervaloId.current = setInterval(async () => {
      await buscarNotificacoesHandler();
    }, 30000);

    return () => {
      clearInterval(intervaloId.current);
    };
  }, []);


  async function buscarNotificacoesHandler() {
    const listarNotificacoesUsuario = await ListarNotificacoesUsuario();
    const totalNotificacao = listarNotificacoesUsuario.notificacaos.filter(n => !n.notificacaoLida).length;


    setCentralNotificacaoValues({
      ...CentralNotificacaoValues,
      notificacoes: listarNotificacoesUsuario.notificacaos,
      totalNotificacao
    });

  }


  async function marcarComoLidoHandler(notificacao) {
    showLoading();
    await MarcarComoLido(notificacao);
    await buscarNotificacoesHandler();
    hideLoading();
  }


  function obterAcaoNotificacaohHandler(notificacao) {

    if (notificacao.notificacaoRotulo === "IR_PARA_ATENDIMENTO" && notificacao.notificacaoCodigo) {
      const id = notificacao.notificacaoCodigo;

      return (
        <button
          className="btn btn-sm btn-success mb-2"
          style={{ fontSize: "smaller" }}
          onClick={() => {
            if (!notificacao.notificacaoLida) {
              MarcarComoLido(notificacao);
              buscarNotificacoesHandler();
            }
            hideModal();
            history.push(`/Atendimento/Atendimento/${id}`);

          }}
        >
          <img src={iconeSearch} alt="" />
        </button>
      );
    }

    return null;
  }



  return (
    <Fragment>
      <div className="row compomenteCentralNotificacaoBorda">
        <div
          className="nav-link dropdown mr-3"
          id="navbarDropdown"
          role="button"
          data-toggle="modal"
          data-target={`#modalCentralNotificacao`}
          data-dismiss="modal"
          onClick={() => { buscarNotificacoesHandler(); }}
        >
          <i className="navBarIconeNotificacoes">
            <FontAwesomeIcon icon={faBell} />
          </i>
          {CentralNotificacaoValues.totalNotificacao > 0 ? <span className="notification-badge">{CentralNotificacaoValues.totalNotificacao}</span> : null}

        </div>
      </div>

      <div
        className="modal fade"
        id={`modalCentralNotificacao`}
        tabIndex="-1"
        role="dialog"
        aria-labelledby={`modalCentralNotificacaoLabel`}
        aria-hidden="true"
      >
        <div className=" modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5
                className="modal-title"
                id={`modalCentralNotificacaoLabel`}
              >
                Central de Notificacões
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="modal-body modalCentralNotificacao">
              <div className="row">
                <div className="col-12 col-md-12">
                  {CentralNotificacaoValues.notificacoes.length > 0 ? (
                    CentralNotificacaoValues.notificacoes.map((notificacao) => (
                      <NotificationItem
                        key={notificacao.notificacaoId}
                        title={notificacao.notificacaoTitulo}
                        description={notificacao.notificacaoDescricao}
                        notificacaoLida={notificacao.notificacaoLida}
                        componentAction={obterAcaoNotificacaohHandler(notificacao)}
                        onMarkAsRead={() => marcarComoLidoHandler(notificacao)}
                      />
                    ))
                  ) : (
                    <div className="text-center p-4">
                      <h5>Nenhuma notificação disponível</h5>
                      <p>Você está em dia! Assim que houver novidades, aparecerão aqui.</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default CentralNotificacao;
